// extracted by mini-css-extract-plugin
module.exports = {"benefits":"BenefitsContainer_benefits__LzMpp","benefits_list":"BenefitsContainer_benefits_list__ZufiG","benefit_icon":"BenefitsContainer_benefit_icon__AHDQ0"};